export default __webpack_public_path__ + "img/catIcon339.cff3a637.svg";